import { render } from "./formWasi.vue?vue&type=template&id=30cc0772&scoped=true"
import script from "./formWasi.vue?vue&type=script&lang=js"
export * from "./formWasi.vue?vue&type=script&lang=js"

import "./formWasi.vue?vue&type=style&index=0&id=30cc0772&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cc0772"]])

export default __exports__